module.exports = __webpack_public_path__ + "static/media/vinefinder-codesnippet2.d36430c9.png";